import { FC } from 'react';
import { StickyFooter } from '@/StickyFooter';
import { Button } from '@mofid-securities/uikit';
import { UserStatusOnClickWrapper } from '@/userStatus/components';
import { useHandleFundActions } from './FundActions.hooks';

export const FundActions: FC = () => {
  const {
    isIssuanceAvailable,
    isRedemptionAvailable,
    handleIssuance,
    handleRedemption,
  } = useHandleFundActions();

  if (!isRedemptionAvailable && !isIssuanceAvailable) {
    return null;
  }

  return (
    <StickyFooter>
      <div className="flex gap-x-4">
        {isIssuanceAvailable && (
          <UserStatusOnClickWrapper>
            <Button
              id="funds_click_issuance"
              isFullWidth
              onClick={handleIssuance}
            >
              خرید
            </Button>
          </UserStatusOnClickWrapper>
        )}
        {isRedemptionAvailable && (
          <Button
            id="funds_click_redemption"
            variant="link"
            isFullWidth
            onClick={handleRedemption}
          >
            فروش
          </Button>
        )}
      </div>
    </StickyFooter>
  );
};
